// @flow
import * as React from 'react';
import { connect } from 'react-redux';
import { resetState } from '../../App/reducer';

type Props = {
  routes: {
    to: string,
    from: string
  },
  resetState: () => void
};

const backgroundRouteMap: Map<string, string> = new Map();

const withBackgroundState = (WrappedComponent: React.AbstractComponent<{}>) => {
  class NewComponent extends React.Component<Props> {
    handleRoutes = () => {
      if (this.props.routes) {
        if (this.props.routes.to === '/') return this.props.resetState();
        const includesRoute = this.props.routes.to.includes(
          this.props.routes.from
        );

        if (includesRoute) {
          backgroundRouteMap.set('route', this.props.routes.from);
        }

        if (!includesRoute) {
          if (backgroundRouteMap.get('route') === this.props.routes.to) return;
          backgroundRouteMap.delete('route');
          this.props.resetState();
        }
      }
    };
    render() {
      this.handleRoutes();
      return <WrappedComponent />;
    }
  }

  const mapStateToProps = state => ({ routes: state.global.routes });

  const mapDispatchToProps = { resetState };

  return connect(mapStateToProps, mapDispatchToProps)(NewComponent);
};

export default withBackgroundState;
